import { createSlice } from '@reduxjs/toolkit'
// import { useDispatch, useSelector } from 'react-redux'
const ONDAY = 1000 * 60 * 60
var canvasObj = ''
var selectedList = [];
const ShouldEyeIconRender=()=>{
  var lcData  = localStorage.getItem(`LC#${Readium.userInfo.id}#${Readium.bookDetails.get('isbn')}#${$("#jumpToPageInput").val().split(" ").join("")}`)
  var notesData  = localStorage.getItem(`notes#${Readium.userInfo.id}#${Readium.bookDetails.get('isbn')}#${$("#jumpToPageInput").val().split(" ").join("")}`)
  if((lcData || notesData) && Global.FOCTOOLPREVIEW)
  {
      $("#eyeIcon").show()
  }else{
      $("#eyeIcon").hide()
    }
  }
const setReaderComponent = (payload,focmode) => {
  var isDual = _epubController.get("isDual");
  var currentView = _epubController.get("dual_current_view");
  var readerItems = ["#save-sync","#next-page-button","#prev-page-button","#book-viewtabs", "#jumpToPage", "#singlePage", "#doublePage", "#progressBar",
    "#options-btn", "#context-menu",  "#audioIcon", "#readerHelpBtn", "#opr-interactive-view", ".opr-fullscreen-icon", "#zoomWrapper", "#arrow-cursor", "#pan-page", "#opr-tts-element", "#exitFullScreenBtn", "#opr-left-toggle-icon"];
  if(focmode)
  {readerItems = ["#save-sync",//"#prev-page-button", "#next-page-button", "#jumpToPage", "#singlePage", "#doublePage", "#progressBar", ".opr-fullscreen-icon", "#exitFullScreenBtn", "#arrow-cursor","#zoomWrapper",
    "#options-btn", "#context-menu",  "#audioIcon", "#readerHelpBtn", "#opr-interactive-view", "#opr-tts-element", "#opr-left-toggle-icon"];}
  readerItems.forEach(function (item) {
    payload == 'disabled' ? $(item).addClass("disabled").prop( "disabled", true ) : $(item).removeClass("disabled").prop( "disabled", false )
  });
  if (payload == 'disabled') {
    $(".bookmark-flag-ribbon").attr('style', 'display: none !important');
    isDual && currentView === Const.FXL ? $('body').addClass('opr-hide-right-panel') : "";
  }
  else {
    ShouldEyeIconRender()
    $("#crootHost").hide();
    $("#drawingToolWrap").addClass("display-none");
    $("#closeCanvas").addClass("display-none");
    $("#readium-right-content").removeClass("opr-border-active");
    $(".bookmark-flag-ribbon").show();
    $("#penDrawer").removeClass("active");
    isDual && currentView === Const.FXL ? $('body').removeClass('opr-hide-right-panel') : "";
  }
}
const canvasCleanup = () => {
  Object.entries(localStorage).filter(x => {
    if (x[0].indexOf("LC#") == 0 || x[0].indexOf("notes#") == 0) {
      if ((Date.now() - JSON.parse(localStorage.getItem(x[0])).date) > ONDAY) {
        console.log(x[0])
        localStorage.removeItem(x[0])
      }
    }
  })
}
const converthsla = (state, payload) => {
  var perVal = payload / 100;
  let r = 0, g = 0, b = 0;
  var H = "#1B4488";
  var color;
  (state.color == '') ? color = "#1B4488" : color = state.color
  H = state.color;
  if (H.length == 4) {
    r = "0x" + H[1] + H[1];
    g = "0x" + H[2] + H[2];
    b = "0x" + H[3] + H[3];
  } else if (H.length == 7) {
    r = "0x" + H[1] + H[2];
    g = "0x" + H[3] + H[4];
    b = "0x" + H[5] + H[6];
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  let cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin,
    h = 0,
    s = 0,
    l = 0;

  if (delta == 0)
    h = 0;
  else if (cmax == r)
    h = ((g - b) / delta) % 6;
  else if (cmax == g)
    h = (b - r) / delta + 2;
  else
    h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0)
    h += 360;

  l = (cmax + cmin) / 2;
  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);
  return ("hsla(" + h + "," + s + "%," + l + "%, " + perVal + ")")

}
export const Current = createSlice({
  name: 'current',
  initialState: {
    focmode:undefined,
    selecteditem: 'Pencil',
    selectedtool: '',
    selectedtool2: '',
    previoustool: '',
    canvasDiv: '',
    selected: true,
    min: 20,
    max: 100,
    radius: 2,
    hideCloseBtn: false,
    color: '#1B4488',
    value: 100,
    itemClicked: '',
    img: false,
    opacity: '',
    canvasObj: '',
    opacityVal: 100,
    showSecondary: false,
    showUndo: true,
    showRedo: true
  },

  reducers: {
    updateProps: (state, { payload }) => {
      state.canvasDiv = payload.canvas;
      state.canvasObj = payload.canvasObj;
      state.focmode= payload.focmode
      setReaderComponent("disabled",payload.focmode)
      canvasObj = payload.canvasObj;
      state.selected = true;
      state.hideCloseBtn = false;
      if (state.canvasObj && state.canvasObj.containerEl.id == '' && !state.focmode) {
        state.selecteditem = 'Pencil';
        state.selectedtool = '';
        state.opacity = '';
        state.value = 100;
        state.opacityVal = 100;
        state.selectedtool2 = '';
        state.radius = 2;
        // state.color = '#FFCC33';
        // state.color = '#D7648D';
        state.color = '#1B4488';
        if (state.canvasObj && state.canvasObj.containerEl.parentNode != null) {
          state.canvasObj.containerEl.parentNode.classList.add("Pencil");
        }
      }
    },
    updateRadius: (state, { payload }) => {
      if (state.selecteditem == "Highlighter" && state.radius == 2) {
        state.radius = 6;
      }
    },
    handleChange: (state, { payload }) => {
      state.value = payload;
      state.opacityVal = payload;
      var hsla = converthsla(state, payload)
      state.canvasObj.setColor('primary', hsla)
      state.opacity = hsla
      // state.showSecondary = false
      console.log(state.opacity)
    },
    handleChangeOpacity:(state, { payload }) => {
      state.value = payload;
      state.opacityVal = payload;
      var hsla = converthsla(state, payload)
      state.canvasObj.setColor('primary', hsla)
      state.opacity = hsla
      state.showSecondary = false
      console.log(state.opacity)
    },
    statename: (state, payload) => {
      if(state.focmode) return
      if (["Undo", "Redo"].includes(payload.payload.name)) { state.showSecondary = false } else {
        state.showSecondary = true
      }
      selectedList.forEach(function (item) {
        document.getElementById(item).classList.remove("disableList");
      })
      state.itemClicked = payload.payload.name;
      state.hideCloseBtn = false;
      if (state.canvasObj == "") {
        state.canvasObj = window.LC.init(document.getElementById(state.canvasDiv), {
          defaultStrokeWidth: state.radius,
          strokeWidths: state.radius,
          secondaryColor: 'transparent',
          scale: Global.getActualZoomValue(),
        });
      }
      var tools =
      {
        Pencil: new window.LC.tools.Pencil(state.canvasObj),
        Highlighter: new window.LC.tools.Pencil(state.canvasObj),
        Eraser: new window.LC.tools.Eraser(state.canvasObj),
        Rectangle: new window.LC.tools.Rectangle(state.canvasObj),
        Ellipse: new window.LC.tools.Ellipse(state.canvasObj),
      }
      if (payload.payload.name === state.selectedtool) {
        if (state.selectedtool != '') {
          state.selectedtool2 = state.selectedtool;
        }
        state.canvasObj.containerEl.parentNode.classList.add(state.selectedtool);
        state.previouistool = state.selectedtool;
      }
      else {
        if (payload.payload.name != "Color" && payload.payload.name != "Notes") {
          for (var key in tools) {

            state.canvasObj.containerEl.parentNode.classList.remove(key);

          }
          state.selectedtool2 != "" ? state.canvasObj.containerEl.parentNode.classList.remove(state.selectedtool2) : "";
          state.selectedtool != "" ? state.canvasObj.containerEl.parentNode.classList.remove(state.selectedtool) : "";
          state.canvasObj.containerEl.parentNode.classList.remove("Pencil");
          state.canvasObj.containerEl.parentNode.classList.add(payload.payload.name);
        }

        if (tools[payload.payload.name]) {
          state.selecteditem = payload.payload.name;
          state.selectedtool = payload.payload.name;
        }
        else {
          state.selectedtool = payload.payload.name;
        }

      }
      if ((payload.payload.name === state.selectedtool2) || (payload.payload.name === state.previoustool)) {

        state.radius = state.radius;
      }
      else {
        state.radius = payload.payload.sizes[0] != undefined ? payload.payload.sizes[0] : state.radius;
        state.selectedtool2 = '';

      }
      if (state.selectedtool === 'Undo' || (state.selectedtool === 'Redo')) {
        state.selecteditem = '';

      }
      var toolObject = tools[state.selecteditem]
      state.previoustool = state.selecteditem
      state.canvasObj.setColor('primary', "#ffeb3b");
      state.canvasObj.containerEl.removeAttribute("id");
      state.canvasObj.containerEl.setAttribute("id", state.selectedtool);
      if (toolObject != undefined) {
        toolObject.strokeWidth = state.radius;
        state.canvasObj.setTool(toolObject);
      }
      if ((state.selecteditem === 'Highlighter') && (state.opacity == '')) {
        //console.log('Opacity is ' + state.opacity)
        state.value = 50
        var hsla = converthsla(state, 50)
        state.canvasObj.setColor('primary', hsla)
      }
      else {
        state.value = state.opacityVal;
        if (toolObject != undefined) {
          state.canvasObj.setTool(toolObject);
        }
        var hsla = converthsla(state, state.value)
        state.canvasObj.setColor('primary', hsla)
      }
    },

    changeColor: (state, payload) => {
      state.color = payload.payload
      console.log(state.color);
      var hsla = converthsla(state, state.value)
      state.canvasObj.setColor('primary', hsla)
      state.selectedtool = ''
    },
    changeRadius: (state, payload) => {
      state.radius = payload.payload
      state.canvasObj.trigger("setStrokeWidth", state.radius)
      state.selected = !state.selected;
      state.showSecondary = false
    },
    clearall: (state) => {
      state.canvasObj.clear();
    },
    updateSliderBackground: (state, payload) => {
      if (payload.payload.current != null) {
        var item = payload.payload.current;
        var min = state.min;
        var max = state.max;
        var value = (state.value - min) / (max - min) * 100;
        var css = 'background: -webkit-linear-gradient(left, ' + Config.SEEKBAR_COLOR + ' 0%, ' + Config.SEEKBAR_COLOR + ' ' + value + '%, #b5b5b6 ' + value + '%, #b5b5b6 100%);'
        css += 'background: -moz-linear-gradient(left, ' + Config.SEEKBAR_COLOR + ' 0%, ' + Config.SEEKBAR_COLOR + ' ' + value + '%, #b5b5b6 ' + value + '%, #b5b5b6 100%);'
        css += 'background: -o-linear-gradient(left, ' + Config.SEEKBAR_COLOR + ' 0%, ' + Config.SEEKBAR_COLOR + ' ' + value + '%, #b5b5b6 ' + value + '%, #b5b5b6 100%);'
        item.style = css;
      }
    },
    closeCanvas: (state) => {
      try{
      state.canvasObj.undoStack = [];
      state.canvasObj.redoStack = [];
      state.canvasObj.containerEl.parentNode.classList = ""
      state.canvasObj.containerEl.remove();
      state.canvasObj = "";
      // state.color = '#FFCC33';
      // state.color = '#D7648D';
      state.color = '#1B4488';
      state.value = 100;
      state.opacityVal = 100;
      setReaderComponent(null,state.focmode)
      Global.isFOCActive = false
      }catch(e){
        console.log("closeCanvas" , e)
      }
    },
    saveCanvas: (state) => {
      if(state.focmode) return
      var snapshot = {...state.canvasObj.getSnapshot()}
      if(snapshot.shapes.length>0)
        localStorage.setItem(`LC#${Readium.userInfo.id}#${Readium.bookDetails.get('isbn')}#${$("#jumpToPageInput").val().split(" ").join("")}`, JSON.stringify({ ...state.canvasObj.getSnapshot(), date: Date.now() }));
      else{
        localStorage.removeItem(`LC#${Readium.userInfo.id}#${Readium.bookDetails.get('isbn')}#${$("#jumpToPageInput").val().split(" ").join("")}`) 
      }
    },
    loadCanvas: (state) => {
      var snapshot = JSON.parse(localStorage.getItem(`LC#${Readium.userInfo.id}#${Readium.bookDetails.get('isbn')}#${$("#jumpToPageInput").val().split(" ").join("")}`));
      if (snapshot && (Date.now() - snapshot.date) > ONDAY) {
        return
      }
      snapshot && state.canvasObj.loadSnapshot(snapshot)
    },
    handleUndo: (state) => {
      state.showSecondary = false
      canvasObj.undo()
      Current.caseReducers.toggleUndoRedo(state)
    },
    handleRedo: (state) => {
      state.showSecondary = false
      canvasObj.redo()
      Current.caseReducers.toggleUndoRedo(state)
    },
    handleCanvasChange: (state, { payload }) => {
      var x = payload.clientX;
      var y = payload.clientY;
      canvasObj.pointerUp(x, y);
    },
    toggleUndoRedo: (state) => {
      state.showUndo = canvasObj.undoStack.length > 0 ? false : true
      state.showRedo = canvasObj.redoStack.length > 0 ? false : true
    },
    clearUndoRedoStack: (state) => {
      canvasObj.undoStack = []
      canvasObj.redoStack = []
    }
  }
})
const { statename, closeCanvas, updateRadius, updateSliderBackground, handleChange, updateProps, changeColor, changeRadius, clearall, saveCanvas, loadCanvas, hideSecondary, handleRedo, handleUndo, handleCanvasChange, toggleUndoRedo, clearUndoRedoStack,handleChangeOpacity } = Current.actions
export { statename, closeCanvas, updateRadius, updateSliderBackground, handleChange, updateProps, changeColor, changeRadius, clearall, saveCanvas, loadCanvas, hideSecondary, canvasCleanup,ShouldEyeIconRender, handleRedo, handleUndo, handleCanvasChange, toggleUndoRedo, clearUndoRedoStack, handleChangeOpacity }
export default Current.reducer